// @flow
import { createIconSetFromIcoMoon } from 'react-native-vector-icons';
import iconConfig from './selection.json';
const AppIcons = createIconSetFromIcoMoon(iconConfig);

export default AppIcons;

export type Props = {
  name: string,
  size?: number,
  color?: string,
};
